@import "../../../../themes/site/default/assets/common_helpers_non_liquid.scss";

.iframe-wrapper {
  display: inline-block;
  width: 100%;
  max-width: 100%;
  position: relative;

  > .iframe-wrapper__inner {
    height: 0;

    > iframe {
      @extend %covers-parent;
    }
  }
}
